// Copyright (c) 2016 Deere & Company

import Dealers, {getDefaultState} from '../../shared/state/dealers';
import actions from '../../actions-list';

const updateDealerResults = (state, action) =>
    Dealers.update(state, {
        $set: action.dealers
    });

const resetDealers = state =>
    Dealers.update(state, {
        $set: getDefaultState()
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_DEALER_SEARCH_RESULTS]: resetDealers,
        [actions.UPDATE_DEALER_SEARCH_RESULTS_SUCCESS]: updateDealerResults
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};




// WEBPACK FOOTER //
// ./src/product/dealer-search/reducers/dealers.js